import React, { useState, useEffect } from 'react'
import Grid from '@material-ui/core/Grid'
import { toast } from 'react-toastify'
import PropTypes from 'prop-types'
import ProfileButtonsStyled from './styled'
import { ProfilePager, BackButton, ButtonWithIcon, PrintIcon, DeleteIcon } from '../../atoms'
import { Star } from 'lucide-react'
import { AlertDialog } from '../../molecules'
import { getCurrentSectionKey, MODULES } from '../../../config/constants'
import { print } from '../../../utils/print'
import routes from "../../../config/routes";
import _ from "lodash";
import useTotalCount from "../../../api/queries/useTotalCount";
import { useStore } from "react-redux";

const HeaderPofile = ({
  history,
  isLoading = false,
  i18n,
  data,
  addFav,
  className,
  deleteOnboarding,
  match,
  onChangeProfile,
  userId,
  dataInboxRows,
  tablePage,
  tableSetPage,
  tablePerPage,
  filters,
  total,
  fetchItemsInbox,
}) => {

  const { data: totalRQuery } = useTotalCount(
    MODULES.currentModule(),
    getCurrentSectionKey(),
    filters
  );

  let store = useStore();

  const [removeModal, setRemoveModal] = React.useState(false)
  const actionsOptions = [
    {
      value: 'markFavorite',
      text: data && data.is_favorite ? i18n.headerProfileButtons.removeFavorites : i18n.headerProfileButtons.markFavorite,
      icon: <Star />
    },
    { value: 'print', text: i18n.headerProfileButtons.print, icon: <PrintIcon /> },
    { value: 'removeOnboarding', text: i18n.headerProfileButtons.remove, icon: <DeleteIcon /> }
  ]

  const handleClickActionsButton = item => {
    switch (item) {
      case 'markFavorite':
        addFav(data.id, !data.is_favorite, MODULES.ID_ON_BOARDING)
        break
      case 'print':
        print('profilePrint')
        break
      case 'removeOnboarding':
        setRemoveModal(true)
        break
      default:
        break
    }
  }

  const handleDeleteOnboarding = () => {
    if (data.id) {
      deleteOnboarding(data.id, MODULES.ID_ON_BOARDING).then(() => {
        toast.success(i18n.onboarding.deleteSuccess, {
          position: toast.POSITION.BOTTOM_CENTER
        })
        history.push(routes.onboarding + '?keepFilters=1');
      })
    }
  }

  const [id, setId] = useState(userId || _.get(match, 'params.slug'))
  const [isLoadingPage, setIsLoadingPage] = useState(false)
  const [isNavigating, setIsNavigating] = useState(false)
  const [currentItemNum, setCurrentItemNum] = React.useState(1);

  const currentTableRows = dataInboxRows?.data || []
  const currentIndex = _.findIndex(currentTableRows, { id })
  const currentItem = currentTableRows[currentIndex]

  const totalItems = totalRQuery?.total || total || 0

  useEffect(() => {
    if (currentItem?.itemCount) {
      setCurrentItemNum(currentItem.itemCount);
    } else if (currentIndex >= 0 && currentTableRows.length > 0) {
      setCurrentItemNum(currentIndex + 1);
    }
  }, [currentItem, currentIndex, currentTableRows]);

  const handleOnChangePage = (newId) => {
    setId(newId)
    onChangeProfile(newId)
  }

  const getNextPageId = () => {
    if (currentIndex >= 0 && currentTableRows[currentIndex + 1]) {
      navigateToProfile(currentTableRows[currentIndex + 1].id)
    } else {
      changePageInTable(1)
    }
  }

  const getPreviousPageId = () => {
    if (currentIndex >= 0 && currentTableRows[currentIndex - 1]) {
      navigateToProfile(currentTableRows[currentIndex - 1].id)
    } else {
      changePageInTable(-1)
    }
  }

  const hasNextPage = () => {
    return currentItemNum < totalItems && currentItemNum > 0
  }

  const hasPreviousPage = () => {
    return currentItemNum > 1
  }

  const navigateToProfile = (targetId) => {
    history.push(`/profile/${MODULES.ID_ON_BOARDING}/${targetId}`)
    handleOnChangePage(targetId)
  }

  const changePageInTable = async (sumOrRest) => {
    if (isLoadingPage || isNavigating) return;

    setIsNavigating(true);
    setIsLoadingPage(true);
    const newTablePage = tablePage + sumOrRest;

    try {
      tableSetPage(newTablePage);

      const state = store.getState();
      const currentFilters = state.saveSearches.filtersInState;
      const sort = state.processes.sort;

      const initialRange = newTablePage * tablePerPage;
      const finishRange = initialRange + tablePerPage - 1;
      const range = [initialRange, finishRange];

      await fetchItemsInbox(currentFilters, range, sort, MODULES.ID_ON_BOARDING);

      setTimeout(() => {
        const newState = store.getState();
        const newRows = newState.processes.dataInbox?.data || [];

        if (newRows.length > 0) {
          const targetId = sumOrRest > 0 ? newRows[0].id : newRows[newRows.length - 1].id;
          const targetItem = newRows.find(row => row.id === targetId);

          if (targetItem?.itemCount) {
            setCurrentItemNum(targetItem.itemCount);
          }

          navigateToProfile(targetId);
        }
        setIsNavigating(false);
      }, 50);
    } catch (error) {
      console.error('Error loading new page:', error);
      setIsNavigating(false);
    } finally {
      setIsLoadingPage(false);
    }
  };

  return (
    <ProfileButtonsStyled className={className}>
      <Grid container alignItems="center">
        <Grid item sm={3}>
          <BackButton title={i18n.headerProfileButtons.back} onClick={() => {
            localStorage.getItem('backLocation') ? history.push(localStorage.getItem('backLocation')) : history.goBack();
          }} />
        </Grid>
        <Grid item sm={9} className={'buttons-wrapper'}>
          {/* Acciones como en la ficha de talent: botones outline con icono, Eliminar en rojo */}
          <div className="header-actions">
            {actionsOptions.map(option => (
              <ButtonWithIcon
                key={option.value}
                title={option.text}
                Icon={option.icon}
                remove={option.value === 'removeOnboarding' ? 'true' : undefined}
                onClick={() => handleClickActionsButton(option.value)}
              />
            ))}
          </div>

          <ProfilePager
            current={currentItemNum}
            total={totalRQuery && totalRQuery.total ? totalRQuery.total : 0}
            onPrevious={() => getPreviousPageId()}
            onNext={() => getNextPageId()}
            previousDisabled={hasPreviousPage() === false}
            nextDisabled={hasNextPage() === false}
            loading={isLoading || isLoadingPage || isNavigating}
          />
        </Grid>
      </Grid>
      <AlertDialog open={removeModal} onClose={() => setRemoveModal(false)} onSuccess={handleDeleteOnboarding}
        title={i18n.process.deleteModalTitle} text={i18n.process.deleteModalText} />
    </ProfileButtonsStyled>
  )
}

HeaderPofile.propTypes = {
  i18n: PropTypes.object.isRequired,
  data: PropTypes.object,
  addFav: PropTypes.func,
  onGoBack: PropTypes.func,
  className: PropTypes.string,
  deleteOnboarding: PropTypes.func
}

export default HeaderPofile
